<div class="welcome-back-container">
  <ion-icon name="checkmark-circle" color="success" class="check-icon"></ion-icon>

  <h2>{{ 'welcomeBack' | translate }}!</h2>

  <p>{{ 'weSavedYourProgress' | translate }}</p>
  <p>{{ 'letsContinue' | translate }}</p>

  <ion-button
    expand="block"
    color="primary"
    class="welcome-back-continue"
    (click)="continue()">
    {{ 'nextSurvey' | translate }}
  </ion-button>

  <ion-button
    expand="block"
    fill="clear"
    class="welcome-back-start-over"
    (click)="startOver()">
    {{ 'startOver' | translate }}
  </ion-button>
</div>
